export const beyondblackwhite = {
  name: 'Beyond Black & White',
  color: [0.6862745098039216, 0.10980392156862745, 0.10980392156862745, 1],
  bg: [0.3568627450980392, 0.7843137254901961, 0.6745098039215687, 1],
  grid1: [0.9411764705882353, 0.9372549019607843, 0.996078431372549, 1],
  grid2: [0.00784313725490196, 0.0196078431372549, 0.03529411764705882, 1],
}
